var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fragment',[_c('v-select',{attrs:{"items":_vm.edades,"label":_vm.$t('lbl.age'),"outlined":"","dense":""},model:{value:(_vm.edad.edad),callback:function ($$v) {_vm.$set(_vm.edad, "edad", $$v)},expression:"edad.edad"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }